<template>
  <v-container fluid pa-0>
    <v-data-table
      :headers="headers"
      :items="tenders"
      :footer-props="{ 'items-per-page-options': [250] }"
      :items-per-page="250"
      class="winners__table"
    >
      <v-progress-linear
        v-slot:progress
        color="primary"
        v-if="false"
        indeterminate
      ></v-progress-linear>
      <template v-slot:item="{ item }">
        <tr @click="openTender(item.id)">
          <td class="text-left">
            <v-chip class="ma-2 ml-0" label outlined :link="false"
              >№{{ item.notification_number }}</v-chip
            >
            <div>{{ item.name }}</div>
          </td>
          <td class="text-center winners__table-date">
            {{ item.protokol_date | formatDate }}
          </td>
          <td class="text-center">{{ item.price | formatPrice }}</td>
          <td class="text-center">{{ item.guaranteeing | formatPrice }}</td>
          <!--<td class="text-left">{{item.placer_name}}</td>-->
          <td class="text-center">{{ item.region }}</td>
        </tr>
      </template>

      <template v-slot:no-data>
        <div class="winners--empty">
          <h2>{{ $t("components.client.tenders.empty") }}</h2>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
//import { apiCallTrue } from "@/utils/api";
import formatDate from "@/mixins/filters/formatDate";
import formatPrice from "@/mixins/filters/formatPrice";
import i18n from "@/services/i18n";

export default {
  name: "ClientTenders",
  mixins: [formatDate, formatPrice],
  data: () => ({
    isLoaded: false,
    headers: [
      {
        text: i18n.t("components.client.tenders.table.fields.name"),
        name: i18n.t("components.client.tenders.table.fields.name"),
        value: "name",
        align: "left",
        sortable: true,
        disabledColumn: true,
      },
      {
        text: i18n.t("components.client.tenders.table.fields.protokol_date"),
        name: i18n.t("components.client.tenders.table.fields.protokol_date"),
        value: "protokol_date",
        align: "center",
        sortable: true,
        disabledColumn: false,
      },
      {
        text: i18n.t("components.client.tenders.table.fields.price"),
        name: i18n.t("components.client.tenders.table.fields.price"),
        value: "price",
        align: "right",
        sortable: true,
        disabledColumn: false,
      },
      {
        text: i18n.t("components.client.tenders.table.fields.guaranteeing"),
        name: i18n.t("components.client.tenders.table.fields.guaranteeing"),
        value: "guaranteeing",
        align: "right",
        sortable: true,
        disabledColumn: false,
      },
      /* {
        text: i18n.t('components.client.tenders.table.fields.winner_name'),
        name: i18n.t('components.client.tenders.table.fields.winner_name'),
        value: "winner_name",
        align: "center",
        sortable: true,
        disabledColumn: false
      },*/

      {
        text: i18n.t("components.client.tenders.table.fields.region"),
        name: i18n.t("components.client.tenders.table.fields.region"),
        value: "region",
        align: "center",
        sortable: true,
        disabledColumn: false,
      },
    ],
  }),
  props: {
    tenders: {
      type: Array,
    },
  },
  computed: {},
  methods: {
    openTender(id) {
      Object.assign(document.createElement("a"), {
        target: "_blank",
        href: "/tenders/" + id,
      }).click();
    },
  },
};
</script>

<style scoped></style>
